import { render } from "./lessons-list.vue?vue&type=template&id=51c8f9c8&scoped=true"
import script from "./lessons-list.vue?vue&type=script&lang=js"
export * from "./lessons-list.vue?vue&type=script&lang=js"

import "./lessons-list.vue?vue&type=style&index=0&id=51c8f9c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c8f9c8"]])

export default __exports__